export class ApprovalApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ApprovalApiError';
  }
}
